import React, { useState, useEffect } from 'react';
import './App.css';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import AboutUs from './pages/aboutus';
import Home from './pages/Home';
import Services from './pages/services.jsx';
import Gallery from './pages/pictures.jsx';
import Appointment from './pages/appointment.jsx';
import Impressum from './pages/impressum.jsx';
import ReactGA from 'react-ga4';
import Cookies from "js-cookie";
import CookieConsent from "react-cookie-consent";
import PrivacyPolicy from './pages/privacy-policy.jsx';
import AdminLogin from "./pages/AdminLogin";
import AdminGallery from "./pages/AdminGallary";
import { API_URL } from './config.js'; 
import AdminSettings from "./pages/AdminSettings.jsx";
import BackgroundSlider from './components/BackgroundSlider';

function App() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [isAdmin, setIsAdmin] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  useEffect(() => {
  if (Cookies.get("CookieConsent") === "true") {
    ReactGA.initialize("G-XXPFPBJYVT");
    ReactGA.send("pageview");
  }
}, []);
useEffect(() => {
    const token = localStorage.getItem("jwt");
    if (token) {
      fetch(`${API_URL}/api/admin/status`, {
        headers: { "Authorization": "Bearer " + token }
      })
        .then(res => res.json())
        .then(data => setIsAdmin(data.loggedIn));
    }
  }, []);

  

  return (
    <Router>
      <div className="App">
        <BackgroundSlider />
        <nav className={`navbar ${scrolled ? "scrolled" : ""}`}>
          <div className="navbar-logo">
            <Link to="/" onClick={() => setMenuOpen(false)}>
              <img className='App-logo' src="/CG_LOGO_t.PNG" alt="Firmenlogo" />
            </Link>
          </div>
          <div
            className="navbar-toggle"
            onClick={() => setMenuOpen(open => !open)}
            aria-label="Menü öffnen/schließen"
            tabIndex={0}
            role="button"
          >
            <span />
            <span />
            <span />
          </div>
          <ul className={`navbar-menu${menuOpen ? " open" : ""}`}>
            <li><Link to="/ueber-uns" onClick={() => setMenuOpen(false)}>Über uns</Link></li>
            <li><Link to="/leistungen" onClick={() => setMenuOpen(false)}>Leistungen</Link></li>
            <li><Link to="/termin" onClick={() => setMenuOpen(false)}>Termin Vereinbaren</Link></li>
            <li><Link to="/bilder" onClick={() => setMenuOpen(false)}>Bilder</Link></li>

          </ul>
        </nav>
        <CookieConsent
  location="none"
  style={{
    position: "fixed",
    left: "50%",
    top: "50%",
    transform: "translate(-50%, -50%)",
    background: "#181818",
    color: "#fff",
    fontSize: "1.2rem",
    padding: "2rem 2.5rem",
    boxShadow: "0 8px 32px rgba(0,0,0,0.25)",
    borderRadius: "18px",
    zIndex: 9999,
    width: "90%",
    maxWidth: 480,
    textAlign: "center",
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  }}
  buttonStyle={{
    background: "#ffa726",
    color: "#222",
    fontWeight: "bold",
    fontSize: "1.15rem",
    borderRadius: "8px",
    padding: "0.9rem 2.5rem",
    margin: "1.2rem 0.7rem 0 0.7rem",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 2px 8px rgba(0,0,0,0.10)"
  }}
  declineButtonStyle={{
    background: "#444",
    color: "#fff",
    fontWeight: "bold",
    fontSize: "1.15rem",
    borderRadius: "8px",
    padding: "0.9rem 2.5rem",
    margin: "1.2rem 0.7rem 0 0.7rem",
    border: "none",
    cursor: "pointer"
  }}
  buttonText="Akzeptieren"
  declineButtonText="Ablehnen"
  enableDeclineButton
  onAccept={() => {
    ReactGA.initialize("G-XXPFPBJYVT");
    ReactGA.send("pageview");
  }}
  onDecline={() => {
    // Google Analytics NICHT aktivieren
  }}
>
  Wir verwenden Cookies, um Ihnen das beste Nutzererlebnis zu bieten. Cookies helfen uns, unsere Website zu verbessern, Inhalte zu personalisieren und Ihnen relevante Informationen anzuzeigen. 
  <br /><br />
  Mit Ihrer Zustimmung erlauben Sie uns außerdem, anonyme Nutzungsstatistiken (z.B. mit Google Analytics) zu erfassen. Sie können Ihre Entscheidung jederzeit in der Datenschutzerklärung widerrufen.
  <br />
  <Link to="/datenschutz" style={{ color: "#ffa726", textDecoration: "underline", marginLeft: 8 }}>
    Mehr erfahren
  </Link>
</CookieConsent>
        {/* Header/Hero removed from global layout to avoid duplication on Home page */}
        <main>
          <Routes>
            <Route path="/ueber-uns" element={<AboutUs />} />
            <Route path="/" element={<Home />}/>
            <Route path="/leistungen" element={<Services />} />
            <Route path="/bilder" element={<Gallery />} />
            <Route path="/termin" element={<Appointment />} />
            <Route path="/impressum" element={<Impressum />} />
            <Route path="/datenschutz" element={<PrivacyPolicy />} />
            <Route path="/admin/login" element={
            isAdmin
          ? <AdminGallery onLogout={() => setIsAdmin(false)} />
          : <AdminLogin onLogin={() => setIsAdmin(true)} /> 
          
      } />
      <Route path='/admin/settings' element={ isAdmin ? <AdminSettings onLogout={() => setIsAdmin(false)} /> : <AdminLogin onLogin={() => setIsAdmin(true)} />} />
            {/* Weitere Routen für Leistungen, Produkte, Termin, Bilder folgen */}
          </Routes>
        </main>
        <footer className="footer">
  <div className="footer-content">
    <div className="footer-section">
      <h4>Impressum</h4>
      <a href="/impressum" className="footer-link">Impressum</a>
      <a href="/datenschutz" className="footer-link">Datenschutzerklärung</a>
    </div>
    <div className="footer-section">
      <h4>Öffnungszeiten</h4>
      <p>Mo–Fr: 07:00–17:00 Uhr<br/>So, Sa & Feiertag: geschlossen</p>
    </div>
    <div className="footer-section">
      <h4>Kontakt</h4>
      <p>CG Fliesen – Christopher Grabner<br/>
        Tel: <a href="tel:+436642341947" className="footer-link">0664 / 2341947</a><br/>
        E-Mail: <a href="mailto:cg-fliesen@gmx.at" className="footer-link">cg-fliesen@gmx.at</a><br/>
        Adresse: <br/> <a className="footer-link" href="https://www.google.com/maps/place/CG+Fliesen+Christopher+Grabner/@47.169133,15.6179161,21z/data=!4m15!1m8!3m7!1s0x476e45f95bee76a3:0x40097572de68610!2s8181+Mitterdorf+an+der+Raab!3b1!8m2!3d47.1703585!4d15.6149446!16s%2Fm%2F03gwm3b!3m5!1s0x476e455da32816e9:0x657943c91dc1b909!8m2!3d47.1691432!4d15.6180089!16s%2Fg%2F11vy5ttyvw?entry=ttu&g_ep=EgoyMDI1MDYyMi4wIKXMDSoASAFQAw%3D%3D">Mitterdorf an der Raab 95</a> 
      </p>
    </div>
    <div className="footer-section">
      <h4>Folgen Sie uns</h4>
      <div className="footer-socials">
        <a href="https://www.facebook.com/profile.php?id=61559190310623" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
          <i className="fab fa-facebook-f"></i>
        </a>
        <a href="https://www.instagram.com/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
          <i className="fab fa-instagram"></i>
        </a>
        <a href="https://wa.me/436642341947" target="_blank" rel="noopener noreferrer" aria-label="WhatsApp">
          <i className="fab fa-whatsapp"></i>
        </a>
      </div>
    </div>
  </div>
  <div className="footer-bottom">
    &copy; {new Date().getFullYear()} CG Fliesen – Christopher Grabner. Alle Rechte vorbehalten.
  </div>
</footer>
      </div>
    </Router>
  );
}

export default App;
